var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 37,
    viewBox: "0 0 86 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1371_1453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.939 36.2242H59.856L59.4573 35.6231L61.7167 21.207L61.9747 20.9666L65.7861 26.7997L71.939 36.2242Z",
    fill: "#DDB6B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7167 21.2109L59.4572 35.6347L54.4771 28.0137L58.2962 24.4223L58.3119 24.4106L61.7167 21.2109Z",
    fill: "#B29493"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5624 28.743L37.5311 28.7507L26.1596 36.2244H25.925L36.034 26.4392L37.5624 28.743Z",
    fill: "#8B717B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7404 21.8354L65.7861 26.8114L61.9748 20.9705L58.3119 24.4107L58.2963 24.4223L49.7276 20.7339L37.5625 28.7429L36.034 26.4391L25.9251 36.2243H3.47522L13.4551 25.0118L14.1783 29.5457L14.663 22.1612L21.629 16.204L24.9596 18.0889L24.0253 31.4577L29.7326 10.5919L29.7209 10.5066L29.7091 10.4058V10.4019L38.6062 0.240446L39.3294 0.065918H39.3568L39.1457 22.8787L46.0491 8.25711L46.1195 8.34244L47.8004 4.2895L63.1749 17.3946L66.779 14.7767L72.7404 21.8354Z",
    fill: "#6A4542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0569 8.25713L39.1573 22.8787L39.3802 0.0659329L39.6343 0L46.0569 8.25713Z",
    fill: "#CD9994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7325 10.592L24.0253 31.4579L24.9595 18.089L24.9986 18.1123L25.2566 15.7271L29.7325 10.592Z",
    fill: "#946562"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6624 36.2244H71.939L71.0634 34.8941L74.8786 20.2958L74.9451 20.2415L83.6624 36.2244Z",
    fill: "#D6C2AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8787 20.3035L71.0634 34.9057L65.7861 26.8114L72.7404 21.8354L74.8787 20.3035Z",
    fill: "#B29B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2963 24.4223L54.4771 28.0137V28.0098L49.7275 20.7339L58.2963 24.4223Z",
    fill: "#8B717B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.856 36.2242H26.1597L37.5312 28.7505L37.5625 28.735L49.7276 20.73L54.4771 28.0059V27.9981L59.856 36.2242Z",
    fill: "#CD9994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5153 36.9999H0.484727C0.215 36.9999 0 36.6858 0 36.4182C0 36.1506 0.218909 35.8364 0.484727 35.8364H85.5153C85.785 35.8364 86 36.1506 86 36.4182C86 36.6858 85.7811 36.9999 85.5153 36.9999Z",
    fill: "#593A38"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1371_1453"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 37,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/noData.ee221ce5.svg";
export { ForwardRef as ReactComponent };